export default __webpack_public_path__ + "static/media/impayé_icon.097f4e5b.svg";